import { gql } from '@apollo/client';

const INIT_ONE_STREAM_FILE_DOWNLOAD = gql`
  mutation InitOneStreamFileDownload($id: ID!) {
    initOneStreamFileDownload(id: $id)
  }
`;

export default INIT_ONE_STREAM_FILE_DOWNLOAD;
